<template>
  <div class="mt-4">
    <v-list>
      <div class="flex flex-column logo-big" @click="$router.push('/')">
        <logo :white="$store.getters.themeDark" />
        <div>хот-спот</div>
      </div>

      <v-list-tile
        v-for="item in items"
        :key="item.title"
        :to="item.route"
        :class="{ 'v-list__tile-active': item.active }"
        role="button"
      >
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile
        v-if="!['sm', 'xs'].includes($vuetify.breakpoint.name)"
        @click="$emit('openSecondPanel', 'supportForm')"
      >
        <v-list-tile-title>Тех.поддержка</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="logout">
        <v-list-tile-title>
          <icon-out class="mr-2"></icon-out>
          <span class="valign-middle">Выход</span>
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import IconOut from "../icon/IconOut.vue";
import Logo from "../common/Logo.vue";

export default {
  name: "NavigationLeft",

  components: {
    IconOut,
    Logo
  },

  data: () => ({}),

  computed: {
    // признак загрузки списка хотспотов
    isHotspotList() {
      return !!this.$store.getters.hotspotList.length;
    },
    // объект с основным меню
    items() {
      let list = [
        {
          title: "Главная",
          route: { name: "hotspot" },
          active: this.$route.name === "hotspot"
        }
      ];
      // если список хотспотов не пустой, то роуты ниже будут будут отображаться в меню
      if (this.isHotspotList) {
        list.push(
          {
            title: "Детализация СМС",
            route: { name: "detailing" },
            active: this.$route.name === "detailing"
          },
          {
            title: "Статистика",
            route: { name: "statistics" },
            active: this.$route.name === "statistics"
          },
          {
            title: "Темы авторизации",
            route: { name: "theme" },
            active: this.$route.name === "theme"
          },
          {
            title: "Рекламные кампании",
            route: { name: "advertising" },
            active: this.$route.name === "advertising"
          },
          {
            title: "Опросы",
            route: { name: "polls" },
            active: this.$route.name === "polls"
          }
        );
      }

      // добавляем роуты только для мобильных
      if (["sm", "xs"].includes(this.$vuetify.breakpoint.name)) {
        list.push(
          {
            title: "Тех. поддержка",
            route: { name: "support" },
            active: this.$route.name === "support"
          },
          {
            title: "Профиль",
            route: { name: "profile" },
            active: this.$route.name === "profile"
          }
        );
      }

      return list;
    }
  },

  methods: {
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    }
  }
};
</script>
